export default __webpack_public_path__ + "static/media/product12.f89449d8.webp";